<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :right="isCanDelete?'iconclosex':''" @rightClick="onDeletePic" />
    <div v-if="loading && data.state==='FINISH'" class="fastRect">
      <div class="title">认证结果</div>
      <img :src="GetServiceUrl()+'image/getPadiTemplateCard?id='+data.picId+'&time='+data.cardTime+'&sign=' +data.cardSign" style="width:100%;">
    </div>
    <div v-if="loading" class="fastRect">
      <div class="title">认证信息</div>
      <van-field
        v-model="data.picId"
        readonly
        label="认证号"
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>状态</span></div>
        <div :style="'color: '+GetColorMain()">
          <b>{{ GetEnumText('Em_DivePicState', data.state) }}</b>
          <div v-if=" data.state==='ERROR'" class="stateRemark">
            请耐心等待重新处理......
          </div>
          <div v-if=" data.state==='MANUAL'" class="stateRemark">
            正在重新处理中，请耐心等待......
          </div>
        </div>
      </div>
      <van-field
        v-model="data.groupTeam"
        readonly
        label="机构"
      />
      <van-field
        v-model="data.picTypeName"
        readonly
        label="类型"
      />
      <van-field
        v-model="data.courseShow"
        readonly
        label="证书"
      />
      <div v-if="data.isFastService" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>服务</span></div>
        <div>
          急速认证
        </div>
      </div>
      <div v-if="data.isPhysicsCard" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>实体卡</span></div>
        <div>
          非潜水机构官方定制卡
        </div>
      </div>
      <van-field
        v-model="data.remark"
        readonly
        label="备注"
      />
      <van-field
        v-model="createTime"
        readonly
        label="创建时间"
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>认证日期</span></div>
        <div>
          {{ formatDate(data.certificationDate,"yyyy/MM/dd") }}
        </div>
      </div>
      <template v-if="data.state==='WAITCONFIRM' && data.userConfirmTime">
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>申请时间</span></div>
          <div>
            {{ formatDate(data.userConfirmTime,"yyyy/MM/dd hh:mm",true) }}
          </div>
        </div>
      </template>
      <template v-if="data.verifyProTime">
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>审核时间</span></div>
          <div :style="'color: '+GetColorMain()">
            {{ formatDate(data.verifyProTime,"yyyy/MM/dd hh:mm",true) }}
          </div>
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>审核意见</span></div>
          <div :style="'color: '+GetColorMain()">
            {{ data.verifyProAbout }}
          </div>
        </div>
      </template>
      <div v-if="data.timePay" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>支付时间</span></div>
        <div>
          {{ formatDate(data.timePay,"yyyy/MM/dd hh:mm",true) }}
        </div>
      </div>
    </div>
    <div v-if="loading && data.certificateInfo" class="fastRect">
      <div class="title">证书信息</div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>机构</span></div>
        <div>
          {{ data.certificateInfo.groupTeam }}
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>证书编号</span></div>
        <div>
          {{ data.certificateInfo.certificateId }}
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>名称</span></div>
        <div>
          {{ data.certificateInfo.certificateName }}
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>学员</span></div>
        <div>
          {{ data.certificateInfo.lastName }}  {{ data.certificateInfo.firstName }}
        </div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>生日</span></div>
        <div>
          {{ formatDate( data.certificateInfo.birthday,"yyyy/MM/dd") }}
        </div>
      </div>
    </div>
    <div v-if="loading && data.customerInfo" class="fastRect">
      <div class="title">学员信息</div>
      <van-field
        v-model="data.customerInfo.loaclName"
        label="本地姓名"
        readonly
        placeholder="请输入本地姓名"
      />
      <van-field
        v-model="data.customerInfo.lastName"
        label="英文(拼音)姓"
        readonly
        placeholder="请输入英文(拼音)姓"
      />
      <van-field
        v-model="data.customerInfo.firstName"
        label="英文(拼音)名"
        placeholder="请输入英文(拼音)名"
        readonly
      />
      <van-field
        v-model="birthday"
        label="生日"
        placeholder="请选择出生日期"
        readonly
      />
      <van-field
        v-model="data.customerInfo.email"
        label="邮箱"
        placeholder="请输入电子邮箱"
        readonly
      />
      <van-field
        v-model="sex"
        label="性别"
        placeholder="请选择性别"
        readonly
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>照片</span></div>
        <div class="van-cell__value" style="text-align:left;">
          <van-image
            width="6rem"
            :src="data.customerInfo.headIcon"
          />
        </div>
      </div>
    </div>
    <div v-if="loading && data.customerInfo" class="fastRect">
      <div class="title">邮寄信息</div>
      <van-field
        v-model="data.customerInfo.country"
        required
        label="国家"
        readonly
      />
      <van-field
        v-if="data.customerInfo.country==='CHN'"
        v-model="data.customerInfo.zipString"
        required
        label="地区"
        readonly
      />
      <van-field
        v-if="data.customerInfo.country!=='CHN'"
        v-model="data.customerInfo.cityEng"
        required
        label="城市"
        readonly
      />
      <van-field
        v-model="data.customerInfo.address"
        required
        label="地址"
        readonly
      />
      <van-field
        v-model="data.customerInfo.postalCode"
        required
        label="邮编"
        readonly
      />
      <van-field
        v-model="data.customerInfo.phone"
        required
        label="手机号码"
        readonly
      />
    </div>
    <div v-if="!confirmErrorShow && data.state==='WAITCONFIRM' && data.isShare" class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" :loading="buttonLoading" @click="onConfirmCustomerInfo(true)">信息无误，下一步</van-button>
      <van-button plain type="default" :color="GetColorMain()" style="width:100%" @click="confirmErrorShow=true">信息有误，打回修改</van-button>
    </div>
    <div v-if="data.state==='WAITCONFIRM' && !data.isShare" class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" :loading="buttonLoading" @click="onConfirmCustomerInfoPro(true)">信息无误，下一步</van-button>
      <van-button plain type="default" :color="GetColorMain()" style="width:100%" @click="onConfirmCustomerInfoPro(false)">返回修改</van-button>
    </div>
    <div v-if="data.state === 'WAITPAY'" class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" @click="onPay()">支付认证费用</van-button>
    </div>
    <div v-if="data.state === 'WAITPAYCONFIRM'" class="downButton">
      <van-button plain type="default" :style="'margin-bottom:1em;width:100%;color:'+GetColorMain()+';border-color:'+GetColorMain()" @click="onPayChange()">切换支付方式</van-button>
      <van-button type="danger" :style="'width:100%;background-color: '+GetColorMain()" @click="onPayOrder()">查看支付订单</van-button>
    </div>
    <div v-if="(data.state === 'WAIT'||data.state === 'CREATE') && data.isShare" class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" @click="onShare()">分享链接给用户</van-button>
    </div>
    <div v-if="data.state === 'WAIT' && !data.isShare" class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" @click="onEditCustomerInfo()">修改学员信息</van-button>
    </div>
    <div v-if="data.state === 'CREATE'&& !data.isShare" class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="margin-bottom:1em;width:100%" @click="onEditCustomerInfo()">填写学员信息</van-button>
    </div>
    <div v-if="confirmErrorShow" class="fastRect">
      <van-field
        v-model="confirmErrorStr"
        clearable
        label="审核意见"
        maxlength="128"
        rows="1"
        autosize
        type="textarea"
        placeholder="请输入审核失败意见"
      />
      <van-button plain type="default" :color="GetColorMain()" style="width:50%" @click="confirmErrorShow=false">取消</van-button>
      <van-button type="danger" :color="GetColorMain()" style="width:50%" :loading="buttonLoading" @click="onConfirmCustomerInfo(false)">打回修改</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { GetServiceUrl } from '@/utils/request'
import { Button, Field, Popup, Dialog, Image } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Image.name]: Image,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '证书信息',
      backurl: '/pic/picIndex',
      loading: false,
      picId: undefined,
      createTime: '',
      buttonLoading: false,
      isCanDelete: false,
      data: {

      },
      sex: undefined,
      birthday: undefined,
      zip: undefined,
      confirmErrorShow: false,
      confirmErrorStr: ''
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.picId = this.$route.params.id
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    GetServiceUrl,
    onNext() {
      Dialog.confirm({
        title: '核对认证信息',
        message: '我已经仔细核对认证信息，并确认信息真实准确有效，一旦提交不能撤销!' +
            '\r\n英文(拼音)姓:' + this.data.customerInfo.lastName +
            '\r\n英文(拼音)名:' + this.data.customerInfo.firstName +
            '\r\n生日:' + this.birthday +
            '\r\n邮箱:' + this.data.customerInfo.email
      }).then(() => {
        this.onUploadCustomerInfo()
      })
    },
    onUploadCustomerInfo() {
      this.buttonLoading = true
      request({
        url: '/Pro/UserConfirmCustomerInfo',
        method: 'post',
        params: { code: this.code }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        this.init()
      })
    },
    onBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push(this.backurl)
    },
    onPay() {
      this.$router.push('/pic/picPay/' + this.picId)
    },
    onPayChange() {
      Dialog.confirm({
        title: '切换支付方式',
        message: '我未能进行支付，现在切换支付方式?'
      }).then(() => {
        this.onPay()
      })
    },
    onPayOrder() {
      this.$router.push('/store/pay/0?id=' + this.data.moneyId)
    },
    onShare() {
      this.$router.push('/pic/picShare/' + this.picId)
    },
    onEditCustomerInfo() {
      this.$router.push('/pic/editCustomerInfo/' + this.picId)
    },
    init() {
      request({
        url: '/Pro/getPicById',
        method: 'post',
        params: { picId: this.picId }
      }).then(Response => {
        this.loading = true
        if (!Response.success) {
          return
        }
        this.data = Response.data
        if (this.data.state === 'CREATE' || this.data.state === 'WAIT' || this.data.state === 'WAITCONFIRM' || this.data.state === 'WAITPAY') {
          this.isCanDelete = true
        } else {
          this.isCanDelete = false
        }
        if (this.data.customerInfo) {
          this.birthday = formatDate(this.data.customerInfo.birthday, 'yyyy/MM/dd')
          this.sex = GetEnumText('Em_wxSex', this.data.customerInfo.sex)
        }
        this.createTime = formatDate(this.data.createTime, 'yyyy/MM/dd hh:mm', true)
      })
    },
    onConfirmCustomerInfo(isSuccess) {
      if (!isSuccess) {
        this.onConfirmCustomerInfoDo(isSuccess, false)
        return
      }
      Dialog.confirm({
        title: '核对认证信息',
        message: '我已经仔细核对用户信息准确无误，一旦提交不能撤销!' +
            '\r\n英文(拼音)姓:' + this.data.customerInfo.lastName +
            '\r\n英文(拼音)名:' + this.data.customerInfo.firstName +
            '\r\n生日:' + this.birthday +
            '\r\n邮箱:' + this.data.customerInfo.email
      }).then(() => {
        this.onConfirmCustomerInfoDo(isSuccess, false)
      })
    },
    onConfirmCustomerInfoPro(isSuccess) {
      if (!isSuccess) {
        this.confirmErrorStr = ''
        this.onConfirmCustomerInfoDo(false, true)
        return
      }
      Dialog.confirm({
        title: '核对认证信息',
        message: '我已经仔细核对用户信息准确无误，一旦提交不能撤销!' +
            '\r\n英文(拼音)姓:' + this.data.customerInfo.lastName +
            '\r\n英文(拼音)名:' + this.data.customerInfo.firstName +
            '\r\n生日:' + this.birthday +
            '\r\n邮箱:' + this.data.customerInfo.email
      }).then(() => {
        this.onConfirmCustomerInfoDo(isSuccess, true)
      })
    },
    onConfirmCustomerInfoDo(isSuccess, isPro) {
      this.buttonLoading = true
      request({
        url: '/Pro/ProUserConfirmCustomerInfo',
        method: 'post',
        data: { isSuccess: isSuccess,
          picId: this.picId,
          about: isSuccess ? '' : this.confirmErrorStr
        }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        this.confirmErrorShow = false
        if (isPro) {
          if (isSuccess) {
            this.onPay()
          } else {
            this.onEditCustomerInfo()
          }
        } else {
          this.init()
        }
      })
    },
    onDeletePic() {
      if (this.buttonLoading) {
        return
      }
      Dialog.confirm({
        title: '取消认证订单',
        message: '是否需要取消该认证订单，取消后不可恢复?'
      }).then(() => {
        this.onDeletePicDo()
      })
    },
    onDeletePicDo() {
      this.buttonLoading = true
      request({
        url: '/Pro/cancelPicById',
        method: 'post',
        params: { picId: this.picId }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push(this.backurl)
      })
    }
  }
}
</script>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.fastRect .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}
.downButton{
    margin: 1em;
}
.cutIconRect{
    width: 100%;
    height: 20em !important;
}
.tools{
  position: absolute;
  right: 0.5em;
  top:0.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
  text-align: center;
  background-color: #fff;
}
.IconRect{
  overflow: hidden;
  position: relative;
}
.buttonChooseImg{
  width: 100%;
  color: #fff;
  border:none;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  height: 3em;
  line-height: 3em;
}
.photoAbout{
  font-size: 0.6em;
  color: #999;
}
.customerRect{
  padding: 0.5em 1em;
  border: 1px solid #ccc;
  margin-bottom: 0.5em;
}

.stateRemark{
  font-size: 0.8em;
  color: #999;
}
</style>
